import React, { useEffect } from "react";
import AboutUsImg from "../../Assets/Photos/dark-tech-team.JPG";
import Img from "../../Assets/Photos/IMG_8345.JPG";
import FBImg from "../../Assets/Photos/Fahad-vai.jpg";
import KaImg from "../../Assets/Photos/khorshed-photo.jpg";
import AlImg from "../../Assets/Photos/alamin";
import BUImg from "../../Assets/Photos/borhan.jpg";
import MUImg from "../../Assets/Photos/mayan";
import ALImg from "../../Assets/Photos/alamin.jpg";

import { FaFacebook, FaGithub, FaGlobe, FaLinkedinIn } from "react-icons/fa";
import TechStacks from "../../Components/TechStacks/TechStacks";

const teamMembers = [
  {
    name: "Fahad Bin Bashar",
    role: "Full Stack Developer",
    img: FBImg,
    description:
      "Overseeing all technology operations and evaluating them according to the goals.",
    links: {
      globe: "https://www.facebook.com/fahadbinbashar",
      github: "#",
      linkedin: "#",
      facebook: "#",
    },
  },
  {
    name: "Md Mayin Uddin",
    role: "App Developer",
    img: MUImg,
    description:
      "Overseeing all technology operations and evaluating them according to the goals.",
    links: {
      globe: "#",
      github: "#",
      linkedin: "#",
      facebook: "#",
    },
  },
  {
    name: "Md Borhan Uddin",
    role: "MERN Stack Developer",
    img: BUImg,
    description:
      "Overseeing all technology operations and evaluating them according to the goals.",
    links: {
      globe: "#",
      github: "#",
      linkedin: "#",
      facebook: "#",
    },
  },
  {
    name: "Md Saifur Alamin",
    role: "React Developer",
    img: AlImg,
    description:
      "Overseeing all technology operations and evaluating them according to the goals.",
    links: {
      globe: "#",
      github: "#",
      linkedin: "#",
      facebook: "#",
    },
  },
  {
    name: "Md Khorshed Alam",
    role: "React Developer",
    img: KaImg,
    description:
      "Overseeing all the react js technology operations and evaluating them according to the goals.",
    links: {
      globe: "https://khorshedalam-kbd.web.app/",
      github: "https://github.com/khorshed-alam-kbd/",
      linkedin: "https://www.linkedin.com/in/khorshedalam-kbd/",
      facebook: "https://www.facebook.com/engr.khorshedalam.bd",
    },
  },
  {
    name: "MD AL-AMIN",
    role: "React Developer",
    img: ALImg,
    description:
      "Overseeing all technology operations and evaluating them according to the goals.",
    links: {
      globe: "#",
      github: "#",
      linkedin: "#",
      facebook: "#",
    },
  },
];

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <div className="hero" style={{ backgroundImage: `url(${AboutUsImg})` }}>
        <div className="hero-overlay bg-opacity-60"></div>
        <div className="hero-content text-center text-neutral-content mx-auto max-w-6xl">
          <div className="my-12">
            <h1 className="text-5xl font-bold mb-5">About Us</h1>
            <h1 className="text-xl lg:text-5xl font-bold text-white mb-5">
              Shaping The More Sustainable Digital World
            </h1>
            <p>
              Dark Tech Solutions Inc. combines state-of-the-art technologies to
              drive new values and unlock unexplored client opportunities. We
              promise to deliver promising technology that ensures to rewire the
              global economy for shared notes. Join our forward-thinking doers
              to shape new values in your industry.
            </p>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="mx-auto max-w-6xl hero py-10">
        <div className="hero-content flex-col lg:flex-row gap-4 bg-base-200">
          <img
            src={Img}
            alt="Mission"
            className="lg:w-1/2 rounded-lg shadow-2xl"
          />
          <div className="lg:w-1/2 px-5">
            <h1 className="text-3xl font-bold">Our Mission</h1>
            <p className="py-6 text-justify text-gray-400">
              We aim to serve businesses with customer centric, result oriented,
              cost effective and innovative solutions that open up endless
              customer engaging possibilities and drive value to global clients.
              We work to make our customers happy through dedication and
              professionalism of our team.
            </p>
            <div className="flex items-center gap-4">
              <img
                src={FBImg}
                alt="Fahad Bin Bashar"
                className="rounded-full w-16 h-16"
              />
              <div>
                <p className="text-xl font-bold">Fahad Bin Bashar</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Vision Section */}
      <div className="bg-base-200 py-10">
        <div className="mx-auto max-w-6xl px-5 lg:p-0">
          <div className="text-center mb-10">
            <h1 className="text-3xl font-bold mb-3">
              Building A Better Working World is The Foundation of Our Company
            </h1>
            <p className="text-gray-400">
              We empower our people with the right mindsets and skills to
              navigate what’s next, become the transformative leaders the world
              needs, pursue careers as unique as they are, and build their own
              exceptional dark tech experiences. The ability to invite, leverage
              and learn from different perspectives is key to delivering for our
              clients. We believe diversity and inclusiveness means growth.
            </p>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {teamMembers.map((member, idx) => (
              <div
                key={idx}
                className="card card-compact bg-base-100 shadow-xl"
              >
                <figure>
                  <img
                    src={member.img}
                    className="w-full h-72 "
                    alt={member.name}
                  />
                </figure>
                <div className="card-body">
                  <h2 className="text-xl font-bold">{member.name}</h2>
                  <p className="text-gray-400">{member.role}</p>
                  <p className="text-justify">{member.description}</p>
                  <div className="flex justify-around mt-3 py-3 rounded bg-base-200">
                    <a
                      href={member.links.globe}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaGlobe />
                    </a>
                    <a
                      href={member.links.github}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaGithub />
                    </a>
                    <a
                      href={member.links.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn />
                    </a>
                    <a
                      href={member.links.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* TechStacks Section */}
      <TechStacks />
    </div>
  );
};

export default AboutUs;
